import type { LocalStorageKey } from "src/types"

export function createLocalStorageGetterSetter<T = string>(props: {
  key: LocalStorageKey;
  // convert value to string for storage
  serializeValue: (value: T) => string;
  // convert value from string for use in application
  deserializeValue: (storedValue: string, defaultValue: T) => T;
}): [(v: T) => Promise<T>, (v: T) => Promise<void>] {
  const {
    key, serializeValue, deserializeValue,
  } = props

  const getter = (defaultValue: T): Promise<T> => {
    try {
      const value = localStorage.getItem(key)
      return Promise.resolve(
        value === null
          ? defaultValue
          : deserializeValue(
            value,
            defaultValue,
          ),
      )
    } catch {
      return Promise.resolve(defaultValue)
    }
  }

  const setter = (value: T) => {
    try {
      localStorage.setItem(
        key,
        serializeValue(value),
      )
    } catch {
      // do nothing
    }

    return Promise.resolve()
  }

  return [
    getter,
    setter,
  ]
}
